import * as commWebApi from '@/api/modules/commWebApi';
import { Api, Spectra, SpectraModule } from '@/decorators';

@Spectra({ namespaced: true, name: 'CommWebApi' })
export default class extends SpectraModule {
  @Api() userGetProfile = commWebApi.postCommWebApiUserGetProfile;
  @Api() userFollow = commWebApi.postCommWebApiUserFollow;
  @Api() userUnfollow = commWebApi.postCommWebApiUserUnfollow;
  @Api() userFollowList = commWebApi.postCommWebApiUserFollowList;
  @Api() userCheckFollowing = commWebApi.postCommWebApiUserCheckFollowing;
  @Api() userUpdateProfile = commWebApi.postCommWebApiUserUpdateProfile;
  @Api() userDeleteTag = commWebApi.postCommWebApiUserDeleteTag;
  @Api() auditAuditResult = commWebApi.postCommWebApiAuditAuditResult;
  @Api() auditUpdateTip = commWebApi.postCommWebApiAuditUpdateTip;
  @Api() modelPostPage = commWebApi.postCommWebApiModelPostPage;
  @Api() modelPostFeedback = commWebApi.postCommWebApiModelPostFeedback;
  @Api() currentUserPage = commWebApi.postCommWebApiModelPostCurrentUserPage;
  @Api() modelPostSave = commWebApi.postCommWebApiModelPostSave;
  @Api() modelPostDetail = commWebApi.postCommWebApiModelPostDetail;
  @Api() commentPage = commWebApi.postCommWebApiModelPostCommentPage;
  @Api() commentFeedback = commWebApi.postCommWebApiModelPostCommentFeedback;
  @Api() commentWrite = commWebApi.postCommWebApiModelPostCommentWrite;
  @Api() auditAuditImageResult = commWebApi.postCommWebApiAuditAuditImageResult;
  @Api() sendWorkEmail = commWebApi.postCommWebApiUserVerificationSendWorkEmail;
  @Api() verifyEmail = commWebApi.postCommWebApiUserVerificationVerifyEmail;
  @Api() modelNotifyPage = commWebApi.postCommWebApiNotifyPage;
}
